import DOMPurify from 'dompurify';
import { Directive, DirectiveBinding } from 'vue';

const purifier = DOMPurify();

function stripHtmlFromString(el: HTMLElement, { value }: DirectiveBinding<string>) {
   const div = document.createElement('div');
   div.innerHTML = purifier.sanitize(value);
   el.innerHTML = div.textContent || div.innerText || '';
}

const StripHtml: Directive = {
   mounted: stripHtmlFromString,
   updated: stripHtmlFromString,
};

export default StripHtml;
